export { TutorQuizFirstMention } from "./TutorQuizFirstMention"
export type { TutorQuizFirstMentionProps } from "./TutorQuizFirstMention"
